(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('EntiteParenteDialogController', EntiteParenteDialogController);

    EntiteParenteDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'EntiteParente', 'Agence'];

    function EntiteParenteDialogController ($scope, $stateParams, $uibModalInstance, entity, EntiteParente, Agence) {
        var vm = this;
        vm.entiteParente = entity;
        vm.agences = Agence.query();
        vm.load = function(id) {
            EntiteParente.get({id : id}, function(result) {
                vm.entiteParente = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:entiteParenteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.entiteParente.id !== null) {
                EntiteParente.update(vm.entiteParente, onSaveSuccess, onSaveError);
            } else {
                EntiteParente.save(vm.entiteParente, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
